
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'YbSvgStar',
  props: {
    colors: {
      type: Array as PropType<string[]>,
      default: () => {
        return []
      }
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
})
